module.exports = __webpack_public_path__ + "static/media/calendar.244c391c.svg";